import { render, staticRenderFns } from "./visit-action-area.vue?vue&type=template&id=24e9cfd4&scoped=true"
import script from "./visit-action-area.vue?vue&type=script&lang=ts"
export * from "./visit-action-area.vue?vue&type=script&lang=ts"
import style0 from "./visit-action-area.vue?vue&type=style&index=0&id=24e9cfd4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e9cfd4",
  null
  
)

export default component.exports